import { useMemo } from 'react';
import type { DailyExchangeRates } from '../core/exchange/exchangeRates';
import { useRoleCollection } from './useRoleCollection';

/** Latest daily CUP FX from elTOQUE — one shared doc for god, banker, and lister. */
export function useExchangeRates(): DailyExchangeRates | null {
  const rows = useRoleCollection('exchangeRates', []);
  return useMemo(() => {
    if (!Array.isArray(rows) || rows.length === 0) return null;
    const row = rows[0] as DailyExchangeRates;
    return row?.rates?.length ? row : null;
  }, [rows]);
}
